module.exports = __webpack_public_path__ + "img/3鳳山國中.ccb3f961.jpg";